import React from 'react';
import { RotateCw } from 'lucide-react';

export const SidebarSection = ({ title, children, isCollapsed, onRefresh }) => (
    <div style={{ marginBottom: '16px' }}>
        {!isCollapsed && (
            <div style={{
                padding: '0 12px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                group: 'true'
            }}>
                <span style={{
                    fontSize: '0.62rem',
                    fontWeight: '900',
                    color: 'var(--text-dim)',
                    letterSpacing: '0.2em',
                    textTransform: 'uppercase',
                    opacity: 0.5
                }}>
                    {title}
                </span>
                {onRefresh && (
                    <button 
                        onClick={(e) => { e.stopPropagation(); onRefresh(); }}
                        style={{ 
                            padding: '4px',
                            borderRadius: '6px',
                            color: 'var(--text-dim)',
                            opacity: 0,
                            transition: 'opacity 0.2s',
                        }}
                        className="refresh-trigger"
                    >
                        <RotateCw size={10} />
                    </button>
                )}
            </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: isCollapsed ? 'center' : 'stretch' }}>
            {children}
        </div>
        {isCollapsed && <div style={{ height: '1px', background: 'var(--border-glass)', margin: '16px 12px' }} />}
    </div>
);
